// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterCircleFilledSvg from "@fishx/icons-svg/es/asn/TwitterCircleFilled";
import FishxIcon from '../components/FishxIcon';

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterCircleFilledSvg
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
export default React.forwardRef(TwitterCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TwitterCircleFilled.js
// module id = 4298
// module chunks = 0